import { push } from '@lagunovsky/redux-react-router'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import ColorfulCard from '../../../components/card/ColorfulCard'
import { getEventType } from '../../../events/utils/EventUtils'
import { convertToHex, getEventColor } from '../../../utils/ColorUtil'
import { getDate, getHour } from '../../../utils/DateUtil'
import { findStationTypeUrl } from '../../../utils/StationUtils'
import { Grid } from '@mui/material'
import { lightGrey } from 'utils/constants/ColorTheme'
import { toInteger } from 'lodash'
import { useDispatch } from 'react-redux'

const GlobalEventsCard = ({ event }) => {
    const dispatch = useDispatch()

    const redirect = (path) => {
        dispatch(push(path))
    }

    const veryLightGrey = `${convertToHex(lightGrey.split('rgb')[1].replace('(', '').replace(')', '').split(', ').map(num => toInteger(num)))}50`


    const getUpdateInfo = () => {
        return event.updateDate && event.updateLogin ? (
            <Grid size={12} sx={{ fontSize: '10px', paddingLeft: 6, backgroundColor: veryLightGrey }}>
                { `${i18n.lastUpdateOn} ${getDate(event.updateDate)} ${i18n.atHour} ${getHour(event.updateDate)} ${i18n.by} ${event.updateLogin}` }
            </Grid>
        ) : null
    }

    return (
        <ColorfulCard color={ getEventColor(event.eventType) } onClick={() => redirect(findStationTypeUrl(event.stationType, event.code, event.number))}>
            <Grid container size={12} alignItems={'center'} sx={{ paddingLeft: 1 }}>
                <Grid size={2}>
                    { getDate(event.date) }
                </Grid>
                <Grid size={8}>
                    <Grid sx={{ fontSize: '14px' }}>{ event.comment }</Grid>
                </Grid>
                <Grid size={2}>
                    { getEventType(event) }
                </Grid>
            </Grid>
            { getUpdateInfo() }
        </ColorfulCard>
    )
}

GlobalEventsCard.propTypes = {
    event: PropTypes.arrayOf(PropTypes.shape({})),
}

export default GlobalEventsCard
